import { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from "framer-motion";
import { pageVariants } from './animations/pageVariants';
import { PageWrapperProps } from './interfaces/pageWrapperInterface';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Modal from './components/Modal';
import './App.css';

function PageWrapper({ children, pathname }: PageWrapperProps) {
  return (
    <motion.main
      key={pathname}
      variants={pageVariants}
      initial="initial"
      animate="enter"
      exit="exit"
    >
      {children}
    </motion.main>
  );
}

function App() {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {setIsOpen(false) };

  const location = useLocation();
  return (
    <motion.div className="App">
      <Navbar />
      <AnimatePresence
        mode="wait"
        initial={false}
        onExitComplete={() => {
          if (!window.location.hash) window.scrollTo({ top: 0 });
        }}
      >
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={
            <PageWrapper pathname={location.pathname}>
              <Home />
            </PageWrapper>
          } />
          <Route path="/about" element={
            <PageWrapper pathname={location.pathname}>
              <About />
            </PageWrapper>
          } />
          <Route path="/services" element={
            <PageWrapper pathname={location.pathname}>
              <Services onOpen={() => setIsOpen(true)} />
            </PageWrapper>
          } />
          <Route path="/contact" element={
            <PageWrapper pathname={location.pathname}>
              <Contact />
            </PageWrapper>
          } />
        </Routes>
      </AnimatePresence>
      <Footer />
      <Modal isOpen={isOpen} handleClose={() => { closeModal() }}/>
    </motion.div>
  );
};

export default App;
